import {useEffect,type RefObject} from 'react';

/** Native modal dialogs trap focus, but do not lock mobile document scrolling. */
export function useDialogScrollLock(ref:RefObject<HTMLDialogElement|null>){
 useEffect(()=>{
  const dialog=ref.current;if(!dialog)return;
  let restore:(()=>void)|undefined;
  const sync=()=>{
   if(dialog.open&&!restore){
    const body=document.body,root=document.documentElement;
    const x=window.scrollX,y=window.scrollY;
    const previous={position:body.style.position,top:body.style.top,left:body.style.left,width:body.style.width,overflow:body.style.overflow,rootOverflow:root.style.overflow};
    Object.assign(body.style,{position:'fixed',top:`-${y}px`,left:`-${x}px`,width:'100%',overflow:'hidden'});root.style.overflow='hidden';
    restore=()=>{Object.assign(body.style,{position:previous.position,top:previous.top,left:previous.left,width:previous.width,overflow:previous.overflow});root.style.overflow=previous.rootOverflow;window.scrollTo({left:x,top:y,behavior:'instant'});};
   }else if(!dialog.open&&restore){restore();restore=undefined;}
  };
  const observer=new MutationObserver(sync);observer.observe(dialog,{attributes:true,attributeFilter:['open']});sync();
  return()=>{observer.disconnect();restore?.();};
 },[ref]);
}
